/** @format */
import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { stringify } from 'qs';

import {
    convertKeyNames,
    toCamelCase,
    toSnakeCase,
} from '@toucan/common/helpers/change-case';

function requestFulfilled(
    request: InternalAxiosRequestConfig
): InternalAxiosRequestConfig {
    // if we have no data then we can just return the original request
    if (!request.data) {
        return request;
    }

    // convert our data keys to snake case
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    const data = convertKeyNames(request.data, toSnakeCase);

    // if we need form data instead of json then we need to stringify our data
    if (
        request.headers?.['Content-Type'] ===
        'application/x-www-form-urlencoded'
    ) {
        request.data = stringify(data, {
            encodeValuesOnly: true,
            arrayFormat: 'repeat',
        });
        return request;
    }

    // add our converted json data to the request and return it
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    request.data = data;
    return request;
}

function responseFulfilled(response: AxiosResponse): AxiosResponse {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    response.data = convertKeyNames(response.data, toCamelCase);
    return response;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
function responseRejected(error: any) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
    if (!axios.isCancel(error) && error?.response?.data) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
        error.response.data = convertKeyNames(error.response.data, toCamelCase);
    }
    // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- Legacy code: do not use as an example.
    return Promise.reject(error);
}

export const changeCaseInterceptor = {
    requestFulfilled,
    responseFulfilled,
    responseRejected,
};
